// Utility functions for UserList components

export const getStatusBadge = (status) => {
  const statusConfig = {
    active: { color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)', icon: '✅' },
    blocked: { color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', icon: '⛔' },
    pending: { color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)', icon: '⏳' },
    stopped: { color: '#6b7280', bg: 'rgba(107, 114, 128, 0.1)', icon: '🛑' }
  };

  return statusConfig[status] || statusConfig.pending;
};

export const filterUsers = (users, searchTerm, statusFilter) => {
  const term = (searchTerm || '').toLowerCase();
  return users.filter(user => {
    const matchesSearch =
      !term ||
      user.first_name?.toLowerCase().includes(term) ||
      user.last_name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term);

    let matchesStatus = true;
    if (statusFilter && statusFilter !== 'all') {
      if (statusFilter === 'admin') {
        matchesStatus = Boolean(user.is_admin || user.isAdmin);
      } else if (statusFilter === 'inactive') {
        matchesStatus = user.status === 'inactive' || user.status === 'stopped';
      } else {
        matchesStatus = user.status === statusFilter;
      }
    }

    return matchesSearch && matchesStatus;
  });
};

export const calculateStats = (users) => {
  return {
    total: users.length,
    active: users.filter(u => u.status === 'active').length,
    pending: users.filter(u => u.status === 'pending').length,
    blocked: users.filter(u => u.status === 'blocked').length,
    stopped: users.filter(u => u.status === 'stopped').length
  };
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString();
};

export const getAvailableActions = (userStatus) => {
  const actions = [];
  
  if (userStatus === 'pending') {
    actions.push({ key: 'approve', label: '⏳ Approve', color: '#10b981' });
  }
  
  if (userStatus !== 'active') {
    actions.push({ key: 'activate', label: '✅ Activate', color: '#10b981' });
  }
  
  if (userStatus !== 'blocked') {
    actions.push({ key: 'block', label: '⛔ Block', color: '#ef4444' });
  }
  
  if (userStatus !== 'stopped') {
    actions.push({ key: 'stop', label: '🛑 Stop', color: '#6b7280' });
  }
  
  return actions;
};

export const validateBulkAction = (action, selectedUsers) => {
  if (!action || selectedUsers.length === 0) {
    return { valid: false, message: 'Please select an action and users' };
  }
  
  return { valid: true };
}; 